module.exports = __webpack_public_path__ + "img/updateInsurance.7a2cdd23.png";